export default __webpack_public_path__ + "static/media/toyota-protect-you-and-loved-ones.95c20db3.svg";